import { Component, HostBinding } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'

import { filter } from 'rxjs/operators'

import { linxioAnimations } from '@shared/animations'

@Component({
  selector: 'lin-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  animations: linxioAnimations,
  standalone: false,
})
export class LinxioContentComponent {
  @HostBinding('@routerTransitionUp') routeAnimationUp = false
  @HostBinding('@routerTransitionDown') routeAnimationDown = false
  @HostBinding('@routerTransitionRight') routeAnimationRight = false
  @HostBinding('@routerTransitionLeft') routeAnimationLeft = false
  @HostBinding('@routerTransitionFade') routeAnimationFade = false

  routerAnimation = 'fadeIn'

  constructor(private router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      switch (this.routerAnimation) {
        case 'fadeIn':
          this.routeAnimationFade = !this.routeAnimationFade
          break
        case 'slideUp':
          this.routeAnimationUp = !this.routeAnimationUp
          break
        case 'slideDown':
          this.routeAnimationDown = !this.routeAnimationDown
          break
        case 'slideRight':
          this.routeAnimationRight = !this.routeAnimationRight
          break
        case 'slideLeft':
          this.routeAnimationLeft = !this.routeAnimationLeft
          break
      }
    })
  }
}
